import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Button, Table, Select } from 'antd';
import ColumnNameSelector from './ColumnNameSelector';

import style from './index.scss';

const { Option } = Select;

const DEFAULT_STATE = {
  selectedSortOrder: 'DESC',
  selectedColumn: null,
  selectedColumnGroupIndex: null
};

class SortComponent extends React.Component {
  state = {
    ...DEFAULT_STATE
  };

  onChangeSortItem = () => {
    const { selectedColumn, selectedSortOrder } = this.state;
    const { onChange } = this.props;

    if (onChange) {
      if (selectedColumn) {
        onChange({
          columnName: selectedColumn,
          operator: selectedSortOrder
        });
      } else {
        onChange(null);
      }
    }
  };

  onSelectColumnName = (columnName, columnGroupIndex) => {
    const { selectedColumn } = this.state;
    this.setState(
      {
        selectedSortOrder: 'DESC',
        selectedColumn: columnName !== selectedColumn ? columnName : null,
        selectedColumnGroupIndex:
          columnName !== selectedColumn ? columnGroupIndex : null
      },
      () => {
        this.onChangeSortItem();
      }
    );
  };

  onChangeSortOrder = (value) => {
    this.setState(
      {
        selectedSortOrder: value
      },
      () => {
        this.onChangeSortItem();
      }
    );
  };

  render() {
    const { columnGroups } = this.props;
    const {
      selectedColumn,
      selectedSortOrder,
      selectedColumnGroupIndex
    } = this.state;
    const columns = [
      {
        title: 'Column Group',
        dataIndex: 'columnGroup',
        key: 'columnGroup'
      },
      {
        title: 'Column Header',
        key: 'columnItems',
        dataIndex: 'columnItems',
        render: (text, record) => (
          <ColumnNameSelector
            onClickColumnName={this.onSelectColumnName}
            selectedColumnGroupIndex={selectedColumnGroupIndex}
            selectedColumnName={selectedColumn}
            record={record}
          />
        )
      },
      {
        title: 'Sort By',
        key: 'action',
        render: (text, record) =>
          record.columnGroupIndex === selectedColumnGroupIndex ? (
            <Select
              defaultValue={selectedSortOrder}
              onChange={this.onChangeSortOrder}>
              <Option value="DESC">Newest to Oldest</Option>
              <Option value="ASC">Oldest to Newest</Option>
            </Select>
          ) : null
      }
    ];

    const content = () => {
      return (
        <Table columns={columns} dataSource={columnGroups} pagination={false} />
      );
    };

    return (
      <Popover content={content} placement="bottom" trigger="click">
        <Button className={style.sortButton}>
          <i className="fa fa-sort"></i>
        </Button>
      </Popover>
    );
  }
}

SortComponent.propTypes = {
  columnGroups: PropTypes.array,
  onChange: PropTypes.func
};

export default SortComponent;
